import React from "react";
import ToggleSelector from "../../Toggle/ToggleSelector";

const ToggleBar = ({
  label,
  options = [],
  value,
  onChange,
  className = "",
  disabled = false,
  style = {},
  testId,
  id,
}) => {
  const handleChange = (nextValue) => {
    if (!disabled) {
      onChange?.(nextValue);
    }
  };

  return (
    <div className={`account-search-toggle-field ${className}`.trim()} data-testid={testId || id}>
      {label ? <div className="account-search-dropdown__label">{label}</div> : null}
      <div className={disabled ? "account-search-toggle-wrap is-disabled" : "account-search-toggle-wrap"}>
        <ToggleSelector
          data={options}
          value={value}
          onChange={handleChange}
          zeroMargin
          compact
          customStyleClass="account-search-toggle"
          style={{
            minHeight: "var(--account-search-control-height)",
            height: "var(--account-search-control-height)",
            padding: "4px",
            ...style,
          }}
        />
      </div>
    </div>
  );
};

export default ToggleBar;
